import { render } from "./DeliveryModeListItem.vue?vue&type=template&id=79acf60a"
import script from "./DeliveryModeListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryModeListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__